import { createSlice } from "@reduxjs/toolkit";

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  picture: string;
  nickname: string;
  school_id: number;
  school_name: string;
  isAdmin: boolean;
}

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthUser | null;
  token: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuthState: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.isLoading = action.payload.isLoading;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
  },
});

export const { setAuthState } = authSlice.actions;
export default authSlice.reducer;
